// extracted by mini-css-extract-plugin
export default {"crop":"Crop_crop__ZqHAL","crop_ReactCrop":"Crop_crop_ReactCrop__4iIBg"};